import axios from 'axios';

axios.defaults.baseURL = process.env.REACT_SERVER_BASE_URL_LOCAL

export const axiosServer = axios.create({
    baseURL: process.env.REACT_SERVER_BASE_URL_LOCAL,
})

// Returns a nice string by reading the axios error.
export function parseAxiosError(err: any): string {
    let message = err?.response?.data;
    if (!message) message = err?.response;
    if (!message) message = err;
    return message + '';
}